export default function (field) {
  // DISABLE CREATE NEW ITEMS
  field = field.setIn(['config', 'enableCreate'], false);

  return field;
}
